/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Starred_Success_ToastInputs */

const en_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record starred successfully`)
};

const fr_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement ajoute aux favoris`)
};

const de_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufnahme startete erfolgreich`)
};

const it_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record contrassegnato con una stella`)
};

const ru_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись успешно завершена.`)
};

const es_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El registro se ha marcado con éxito`)
};

const zh_cn2_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`唱片公司成功出品`)
};

const ja_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードのスターが正常に作成されました`)
};

const hi_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड ने सफलतापूर्वक अभिनय किया`)
};

const pt_pt2_explorer_info_starred_success_toast = /** @type {(inputs: Explorer_Info_Starred_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record estrelou com sucesso`)
};

/**
* | output |
* | --- |
* | "Record starred successfully" |
*
* @param {Explorer_Info_Starred_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_starred_success_toast = /** @type {((inputs?: Explorer_Info_Starred_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Starred_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_starred_success_toast(inputs)
	if (locale === "de") return de_explorer_info_starred_success_toast(inputs)
	if (locale === "it") return it_explorer_info_starred_success_toast(inputs)
	if (locale === "ru") return ru_explorer_info_starred_success_toast(inputs)
	if (locale === "es") return es_explorer_info_starred_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_starred_success_toast(inputs)
	if (locale === "ja") return ja_explorer_info_starred_success_toast(inputs)
	if (locale === "hi") return hi_explorer_info_starred_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_starred_success_toast(inputs)
	return en_explorer_info_starred_success_toast(inputs)
});